import { PRINCIPAL_TYPES } from '@atlassian/jira-polaris-domain-view/src/view-access/constants.tsx';
import type { PrincipalType } from '@atlassian/jira-polaris-domain-view/src/view-access/types.tsx';

export const isPrincipalTypeItem = (type?: string): type is PrincipalType =>
	type === PRINCIPAL_TYPES.PROFILE || type === PRINCIPAL_TYPES.GROUP;
